// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iBHK","comment":"styles_comment__2TtXD"};